












































import BaseComponent from '@/components/base-component.vue';
import PrescriptionListTranscriptionFilters from '@/components/prescription/list/transcription-filters.vue';
import PrescriptionListTranscriptionTable from '@/components/prescription/list/transcription-table.vue';
import PescriptionForm from '@/components/prescription/prescription-form.vue';
import PrescriptionTranscriptionDiff from '@/components/prescription/transcription/diff.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { ITranscription, TranscricaoFiltroParmDTO } from '@/interfaces/transcription';
import PrescriptionModel from '@/models/prescription-model';
import TranscriptionModel from '@/models/transcription-model';
import * as service from '@/services/prescription';
import { TRANSCRIPTION_REFRESH_TIME } from '@/settings/consts/prescription-params';
import * as prescriptionTypes from '@/settings/consts/prescriptions-types';
import * as TRANSCRIPTION_STATUS from '@/settings/consts/transcription-status';
import * as transcriptionTypes from '@/settings/consts/transcriptions-types';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';


@Component({
  components: {
    ListMessages,
    PescriptionForm,
    PrescriptionTranscriptionDiff,
    PrescriptionListTranscriptionFilters,
    PrescriptionListTranscriptionTable,
    PermissionAuth
  },
})
export default class Transcription extends BaseComponent {
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public isVisualizing: boolean = false;

  public search: any = null;

  public formOpenToCompare: boolean = false;
  public transcriptionsToCompare: PrescriptionModel[] = [];

  public transcriptions: ITranscription[] = [];
  public itemTranscription: TranscriptionModel = new TranscriptionModel();
  public item: PrescriptionModel = new PrescriptionModel();
  public requestTranscriptionsSubject$: BehaviorSubject<
    any
  > = new BehaviorSubject('initialize');
  public pagination: any = {};
  public totalTranscriptions: number = 0;
  public intervalId: any = null;

  private fab: boolean = false;
  private reloadPatientWatch = 0;

  public beforeMount(): void {
    this.registerRequestTranscriptions();
    this.setReloadInterval();    
  }

  public destroyed(): void {
    this.clearReloadInterval();
  }

  public onFilter(value) {
    this.search = value;
    this.pagination.page = 1;
    this.load();
  }

  public onChangePagination(value): void {
    this.pagination = value;
    this.load();
  }

  public openForm(item: any): void {
    this.item = item;
    this.formOpen = true;
    this.isVisualizing = false;
    this.clearReloadInterval();
  }

  public openView(item: any): void {    
    this.openForm(item);
    this.isVisualizing = true;
  }

  public openFormToCompare(
    item: TranscriptionModel,
    items: PrescriptionModel[],
  ): void {
    this.itemTranscription = item;
    this.transcriptionsToCompare = items;
    this.formOpenToCompare = true;
    this.clearReloadInterval();
  }

  public closeCompareForm(): void {
    this.transcriptionsToCompare = [];
    this.formOpenToCompare = false;
  }

  public onSave(): void {
    this.closeForm();
    this.closeCompareForm();
    this.load();
    this.reloadPatientWatch ++;
  }

  public newItem(): void {
    this.item = new PrescriptionModel();
    this.item.tipoTranscricao = transcriptionTypes.TRANSCRIPTION;
    this.item.tipoPrescricao = prescriptionTypes.DEFAULT;
    this.item.viaAdministracao = null;
    this.formOpen = true;
    this.isVisualizing = false;
    this.clearReloadInterval();
  }

  public newItemFromTranscription(item: PrescriptionModel): void {
    this.item = item;
    this.formOpen = true;
    this.clearReloadInterval();
  }

  public closeForm(): void {
    this.item = null;
    this.formOpen = false;
    this.setReloadInterval();
    resetModalScroll('.input-section form');
  }

  public load(): void {    
    if (this.search == null) {
      return;
    }
    const defaultStatus = [
      TRANSCRIPTION_STATUS.WAITING_TRANSCRIPTION.key,
      // TRANSCRIPTION_STATUS.TRANSCRIPTION_IN_PROGRESS.key,
      TRANSCRIPTION_STATUS.WAITING_TRANSCRIPTION_COMPARE.key,
      TRANSCRIPTION_STATUS.WAITING_TRANSCRIPTION_APPROVE.key,
    ];

    let s =  this.search;
    let filter = new TranscricaoFiltroParmDTO();
    filter.idPaciente = s.patientId;
    filter.idMedico = s.doctorId;
    filter.idUnidade = !!s.hospitalUnit ? s.hospitalUnit.id : null;
    filter.dataCriacaoInicio = s.prescriptionCreatedDate[0];
    filter.dataCriacaoFim = s.prescriptionCreatedDate[1];
    filter.dataProducaoInicio = s.productionDate[0];
    filter.dataProducaoFim = s.productionDate[1];
    filter.dataEntregaInicio = s.prescriptionDate[0];
    filter.dataEntregaFim = s.prescriptionDate[1];
    filter.statusTranscricao = !!s.transcriptionStatus ? s.transcriptionStatus : defaultStatus;
    filter.id = s.id;
    filter.minhasTranscricoes = s.typeTranscription;
    filter.bolsaMulti = s.multi;
    filter.update(this.pagination);

    this.requestTranscriptionsSubject$.next(filter);
  }

  private registerRequestTranscriptions(): void {
    this.requestTranscriptionsSubject$
      .pipe(
        skipWhile((val) => {
          return val === 'initialize';
        }),
        tap(() => {
          this.transcriptions = [];
          this.loading = true;
          this.error = false;
        }),
        debounceTime(1000),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listTranscriptions(filter);
        }),
      )      
      .subscribe(res => {
        this.loading = false;
        this.totalTranscriptions = Number(res.totalElements);
        this.transcriptions = res.content.map((trasncription) => new TranscriptionModel(trasncription));
        PaginationSyncDTO.update(this.pagination, res);
      },(err) => {
          this.loading = false;
          this.error = true;
      });
  }

  private setReloadInterval(): void {
    this.intervalId = setInterval(() => {
      this.load();
    }, TRANSCRIPTION_REFRESH_TIME);
  }

  private clearReloadInterval(): void {
    if (!!this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
